<template>
    <div class="bill-item-list" ref="listRef">
        <div v-if="! items.length" class="text-muted text-center py-3">No items added</div>
        <div v-for="(item, index) in items" :key="index" class="bill-item-card mb-2" @click="startEditing(index)">
            <div v-if="editIndex === index" class="row g-2 align-items-end" @click.stop>
                <div class="col-6">
                    <label class="form-label">Qty</label>
                    <input v-model.number="item.quantity" type="number" min="1" class="form-control form-control-sm"/>
                </div>
                <div class="col-6">
                    <label class="form-label">Rate</label>
                    <input v-model.number="item.rate" type="number" min="0" class="form-control form-control-sm"/>
                </div>
            </div>
            <div v-else class="d-flex justify-content-between align-items-center">
                <div class="bill-item-name">{{ item.name }}</div>
                <div class="bill-item-meta">
                    <span>{{ item.quantity }} x {{ item.rate }}</span>
                    <span class="bill-item-amount">{{ lineAmount(item) }}</span>
                    <button type="button" class="btn btn-sm btn-outline-danger" @click.stop="onDelete(index)">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="items.length" class="d-flex justify-content-between align-items-center bill-item-total mt-2">
            <span>Total</span>
            <span>{{ total }}</span>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import useDetectOutsideClick from '@/services/useDetectOutsideClick';

const props = defineProps({
    items: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(['onDeleteItem']);

const listRef = ref(null);
const editIndex = ref(-1);

const lineAmount = (item) => {
    return Number(item.quantity) * Number(item.rate);
};

const total = computed(() => {
    let sum = 0;
    for (const item of props.items) {
        sum += lineAmount(item);
    }
    return sum;
});

const startEditing = (index) => {
    editIndex.value = index;
};

const stopEditing = () => {
    editIndex.value = -1;
};

const onDelete = (index) => {
    emit('onDeleteItem', index);
};

useDetectOutsideClick(listRef, stopEditing);
</script>

<style scoped>
.bill-item-card {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    cursor: pointer;
}
.bill-item-name {
    font-weight: 600;
    font-size: 0.85rem;
    color: #1f2937;
}
.bill-item-meta {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    font-size: 0.82rem;
    color: #4a5568;
}
.bill-item-amount {
    font-weight: 700;
    color: #1f2937;
    min-width: 60px;
    text-align: right;
}
.bill-item-total {
    font-weight: 700;
    font-size: 0.95rem;
    padding: 0.4rem 0.75rem;
    border-top: 1px solid #eef0f3;
}
</style>
